/* eslint-disable no-await-in-loop */
import { getPaged } from '@nbx/frontend-helpers/fetch-api';
import { context } from '@nbx/frontend-helpers/auth';

let baseUrl = 'api/admin';

const NBXAdmins = {
  init: config => ({ baseUrl } = config),

  getAdminTradeHistory: async marketId => {
    const account = await context.account();
    const requestURL = `${baseUrl}/markets/${marketId}/trades`;
    let response = await getPaged(requestURL, account);
    let history = response.body;
    let { pagingState } = response;
    while (pagingState) {
      // sleep 1 second between pages to prevent being blocked by cloudflare
      // eslint-disable-next-line no-promise-executor-return
      await new Promise(r => setTimeout(r, 1000));
      response = await getPaged(requestURL, account, pagingState);
      history = [...history, ...response.body];
      pagingState = response.pagingState;
    }
    history.forEach(trade => {
      trade.makerOrderId = trade.makerOrder.id;
      trade.makerOrderAccountId = trade.makerOrder.account.id;
      trade.makerOrderSide = trade.makerOrder.side;
      trade.takerOrderId = trade.takerOrder.id;
      trade.takerOrderAccountId = trade.takerOrder.account.id;
      trade.takerOrderSide = trade.takerOrder.side;
      delete trade.makerOrder;
      delete trade.takerOrder;
    });
    return history;
  }
};

export default NBXAdmins;
